import { useAuth } from '@workos-inc/authkit-react';
import { useCallback } from 'react';

export const useGetAccessToken = (): (() => Promise<string | undefined>) => {
  const { getAccessToken: workosGetAccessToken, user } = useAuth();

  const getAccessToken = useCallback(async () => {
    if (user === null) {
      return undefined;
    }
    return await workosGetAccessToken();
  }, [user, workosGetAccessToken]);

  return getAccessToken;
};
